var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
        _vm.themeSkin,
        'fixed-layout',
        _vm.isMobile ? { 'mini-sidebar': true, 'show-sidebar': _vm.isMiniSidebar } : { 'show-sidebar': false }
    ],attrs:{"id":"main-wrapper"}},[(_vm.isMobile)?_c('top-bar'):_vm._e(),(!_vm.isMobile || _vm.isMiniSidebar)?_c('left-sidebar'):_vm._e(),_c('div',{staticClass:"page-wrapper"},[(_vm.isMobile && _vm.isMiniSidebar)?_c('div',{staticClass:"overlay",on:{"click":_vm.toggleSideBar}}):_vm._e(),_c('div',{class:[_vm.isMobile ? 'p-2' : 'pl-0 py-2 pr-2']},[(_vm.isMaintenance)?_c('maintenance'):_c('div',{staticClass:"container-fluid"},[(!_vm.isMaintenance)?_c('router-view'):_vm._e()],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }